import React, { createContext, useState } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const ConversationalInterfaceStoreContext = createContext({});
export const ConversationalInterfaceStoreProvider = _ref => {
  let {
    children,
    exercise
  } = _ref;
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const isDownloadFilesExercise = ['DownloadFilesExcelOpenQuestion', 'DownloadFilesExcelMultipleChoice'].includes(exercise.question.flavor);
  const layoutSize = isDownloadFilesExercise ? 'large' : 'small';
  const isRewatchVideoButtonDisplayed = !isDownloadFilesExercise;
  const store = {
    activeTabIndex,
    isRewatchVideoButtonDisplayed,
    layoutSize,
    setActiveTabIndex
  };
  return ___EmotionJSX(ConversationalInterfaceStoreContext.Provider, {
    value: store
  }, children);
};